



















































































































































































































































































































































































































































import { ExpedienteFiltroModel, ExpedienteInterface, IResponseElement, Pagination } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'
import useSweetAlert from '@core/plugins/sweetalert'
import { formatDateTime } from '@core/utils/filter'
import {
  mdiAlertDecagramOutline,
  mdiBookOutline,
  mdiCertificateOutline,
  mdiChevronDown,
  mdiChevronUp,
  mdiClipboardCheckOutline,
  mdiCloseOctagonOutline,
  mdiDotsVertical,
  mdiDownloadBoxOutline,
  mdiDownloadCircleOutline,
  mdiFilterVariantMinus,
  mdiOfficeBuildingMarkerOutline,
  mdiSchoolOutline,
  mdiSendCircleOutline,
  mdiSendOutline,
} from '@mdi/js'
import PaginationFooter from '@shared/components/PaginationFooter.vue'
// Shared
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import { computed, defineComponent, onMounted, ref, watch } from '@vue/composition-api'
import { base64StringToBlob } from 'blob-util'
import * as FileSaver from 'file-saver'
import BandejaProcesoCUModal from '../components/BandejaProcesoCUModal.vue'
import BandejaProcesoDiplomaModal from '../components/BandejaProcesoDiplomaModal.vue'
// Components
import BandejaProcesoFiltro from '../components/BandejaProcesoFiltro.vue'
import BandejaProcesoRegistroLibroModal from '../components/BandejaProcesoRegistroLibroModal.vue'
import BandejaProcesoSuneduModal from '../components/BandejaProcesoSuneduModal.vue'
import useBandejaProcesoEndpoint from '../composables/useBandejaProcesoEndpoint'

export default defineComponent({
  // type inference enabled
  components: {
    PaginationSelect,
    PaginationFooter,
    BandejaProcesoFiltro,
    BandejaProcesoCUModal,
    BandejaProcesoDiplomaModal,
    BandejaProcesoSuneduModal,
    BandejaProcesoRegistroLibroModal,
  },
  setup() {
    const ascending = ref(false)
    const sortColumn = ref('')
    const expedientes = ref<ExpedienteInterface[]>([])
    const expedientesData = computed<ExpedienteInterface[]>(() => store.getters['bandejaProceso/expedientes'])
    const isFilterPanelActive = ref(false)
    const mostrarCUModal = ref(false)
    const mostrarDiplomaModal = ref(false)
    const mostrarSuneduModal = ref(false)
    const mostrarRegistroLibroModal = ref(false)
    const filtro = ref(new ExpedienteFiltroModel())
    const pagination = ref(new Pagination())
    const todoSeleccionado = ref(false)

    const { isLoading } = useAppConfig()
    const { confirm, showPrompt, showMessage } = useSweetAlert()
    const { anular, finalizar, noRecogido, observarSunedu, programar } = useBandejaProcesoEndpoint()

    onMounted(() => {
      obtenerExpedientes(filtro.value)
    })

    watch(expedientesData, () => {
      expedientes.value = expedientesData.value
    })

    const seleccionarTodos = () => {
      expedientes.value = expedientes.value.map((expediente: ExpedienteInterface) => {
        return {
          ...expediente,
          seleccionado: todoSeleccionado.value,
        }
      })
    }

    const seleccionar = () => {
      const expedientesSeleccionados = expedientes.value.filter(
        (expedientes: ExpedienteInterface) => expedientes.seleccionado === true,
      )
      todoSeleccionado.value = expedientesSeleccionados.length === expedientes.value.length
    }

    const filterDate = computed(() => (ISODate: string | null | undefined) => formatDateTime(ISODate))

    const obtenerExpedientes = async (filter: ExpedienteFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProceso/obtenerExpedientes', params)

      if (ok) {
        actualizarPaginacion(response)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<ExpedienteInterface>) => {
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const sortTable = (col: string) => {
      if (sortColumn.value === col) {
        ascending.value = !ascending.value
      } else {
        ascending.value = true
        sortColumn.value = col
      }

      const newAscending = ascending.value

      expedientes.value = expedientes.value.sort(function (a: ExpedienteInterface | any, b: ExpedienteInterface | any) {
        if (a[col] > b[col]) {
          return newAscending ? 1 : -1
        } else if (a[col] < b[col]) {
          return newAscending ? -1 : 1
        }

        return 0
      })
    }

    const descargarFut = async (expediente: ExpedienteInterface) => {
      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProceso/descargarFut', expediente.expedienteId)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    const descargarFichaCU = async (expediente: ExpedienteInterface) => {
      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProceso/descargarFichaCU', expediente.expedienteId)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    const descargarFichaLibro = async (expediente: ExpedienteInterface) => {
      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProceso/descargarFichaLibro', expediente.expedienteId)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    const recepcionar = async (expediente: ExpedienteInterface) => {
      const { value } = await confirm(
        `¿Está seguro de recepcionar el expediente <b>${expediente.numeroExpediente}</b>?`,
        'warning',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await store.dispatch('bandejaProceso/recepcionar', expediente.expedienteId)

        if (ok) {
          showMessage('Éxito!', response.mensaje, 'success')
          obtenerExpedientes(filtro.value)
        }
        isLoading.value = false
      }
    }

    const verConsejoUniversitario = async (expediente: ExpedienteInterface) => {
      isLoading.value = true
      mostrarCUModal.value = true
      const { ok } = await store.dispatch('bandejaProceso/obtenerConsejoUniversitario', expediente.expedienteId)

      if (!ok) {
        mostrarCUModal.value = false
      }
      isLoading.value = false
    }

    const verDiploma = async (expediente: ExpedienteInterface) => {
      store.commit('bandejaProceso/cargarExpediente', expediente)
      mostrarDiplomaModal.value = true
    }

    const verSunedu = async (expediente: ExpedienteInterface) => {
      store.commit('bandejaProceso/cargarExpediente', expediente)
      mostrarSuneduModal.value = true
    }

    const verRegistroLibro = async (expediente: ExpedienteInterface) => {
      store.commit('bandejaProceso/cargarExpediente', expediente)
      mostrarRegistroLibroModal.value = true
    }

    const cuModalOnClose = (actualizar: boolean) => {
      mostrarCUModal.value = false
      if (actualizar) {
        obtenerExpedientes(filtro.value)
      }
    }

    const diplomaModalOnClose = (actualizar: boolean) => {
      mostrarDiplomaModal.value = false
      if (actualizar) {
        obtenerExpedientes(filtro.value)
      }
    }

    const suneduModalOnClose = (actualizar: boolean) => {
      mostrarSuneduModal.value = false
      if (actualizar) {
        obtenerExpedientes(filtro.value)
      }
    }

    const registroLibroModalOnClose = (actualizar: boolean) => {
      mostrarRegistroLibroModal.value = false
      if (actualizar) {
        obtenerExpedientes(filtro.value)
      }
    }

    const expedienteProgramar = async () => {
      const expedientesData: number[] = expedientes.value
        .filter((expediente: ExpedienteInterface) => expediente.seleccionado)
        .filter((expediente: ExpedienteInterface) => expediente.estadoCodigo === 'ESX004')
        .map((expediente: ExpedienteInterface) => expediente.expedienteId) as number[]

      if (expedientesData.length === 0) {
        showMessage(
          'Advertencia!',
          'Debe seleccionar al menos un expediente en estado <b>PARA IMPRESIÓN</b>',
          'warning',
        )

        return
      }

      const { value } = await showPrompt(
        'textarea',
        'Advertencia!',
        `¿Está seguro de programar los expedientes seleccionados"?`,
        'Programar',
        'warning',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await programar({
          observacion: value,
          expedientes: expedientesData,
        })

        if (ok) {
          showMessage('Éxito!', response?.mensaje, 'success')
          obtenerExpedientes(filtro.value)
        }
        isLoading.value = false
      }
    }

    const expedienteObservarSunedu = async () => {
      const expedientesData: number[] = expedientes.value
        .filter((expediente: ExpedienteInterface) => expediente.seleccionado)
        .filter((expediente: ExpedienteInterface) => expediente.estadoCodigo === 'ESX005')
        .map((expediente: ExpedienteInterface) => expediente.expedienteId) as number[]

      if (expedientesData.length === 0) {
        showMessage(
          'Advertencia!',
          'Debe seleccionar al menos un expediente en estado <b>ENVIADO A SUNEDU</b>',
          'warning',
        )

        return
      }

      const { value } = await showPrompt(
        'textarea',
        'Advertencia!',
        `¿Está seguro de observar a SUNEDU los expedientes seleccionados"?`,
        'Observar',
        'warning',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await observarSunedu({
          observacion: value,
          expedientes: expedientesData,
        })

        if (ok) {
          showMessage('Éxito!', response?.mensaje, 'success')
          obtenerExpedientes(filtro.value)
        }
        isLoading.value = false
      }
    }

    const expedienteNoRecogido = async () => {
      const expedientesData: number[] = expedientes.value
        .filter((expediente: ExpedienteInterface) => expediente.seleccionado)
        .filter((expediente: ExpedienteInterface) => expediente.estadoCodigo === 'ESX005')
        .map((expediente: ExpedienteInterface) => expediente.expedienteId) as number[]

      if (expedientesData.length === 0) {
        showMessage(
          'Advertencia!',
          'Debe seleccionar al menos un expediente en estado <b>ENVIADO A SUNEDU</b>',
          'warning',
        )

        return
      }

      const { value } = await showPrompt(
        'textarea',
        'Advertencia!',
        `¿Está seguro de colocar a <b>NO RECOGIDO</b> los expedientes seleccionados"?`,
        'Sí',
        'warning',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await noRecogido({
          observacion: value,
          expedientes: expedientesData,
        })

        if (ok) {
          showMessage('Éxito!', response?.mensaje, 'success')
          obtenerExpedientes(filtro.value)
        }
        isLoading.value = false
      }
    }

    const expedienteFinalizar = async () => {
      const expedientesData: number[] = expedientes.value
        .filter((expediente: ExpedienteInterface) => expediente.seleccionado)
        .filter(
          (expediente: ExpedienteInterface) =>
            expediente.estadoCodigo === 'ESX005' ||
            expediente.estadoCodigo === 'ESX006' ||
            expediente.estadoCodigo === 'ESX007',
        )
        .map((expediente: ExpedienteInterface) => expediente.expedienteId) as number[]

      if (expedientesData.length === 0) {
        showMessage(
          'Advertencia!',
          'Debe seleccionar al menos un expediente en estado <b>ENVIADO A SUNEDU</b>, <b>OBSERVADO POR SUNEDU</b> o <b>NO RECOGIDO</b>',
          'warning',
        )

        return
      }

      const { value } = await showPrompt(
        'textarea',
        'Advertencia!',
        `¿Está seguro de finalizar los expedientes seleccionados"?`,
        'Finalizar',
        'warning',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await finalizar({
          observacion: value,
          expedientes: expedientesData,
        })

        if (ok) {
          showMessage('Éxito!', response?.mensaje, 'success')
          obtenerExpedientes(filtro.value)
        }
        isLoading.value = false
      }
    }

    const expedienteAnular = async () => {
      const expedientesData: number[] = expedientes.value
        .filter((expediente: ExpedienteInterface) => expediente.seleccionado)
        .map((expediente: ExpedienteInterface) => expediente.expedienteId) as number[]

      if (expedientesData.length === 0) {
        showMessage('Advertencia!', 'Debe seleccionar al menos un expediente en para Anular', 'warning')

        return
      }

      const { value } = await showPrompt(
        'textarea',
        'Advertencia!',
        `¿Está seguro de <b>Anular</b> los expedientes seleccionados"?`,
        'Anular',
        'danger',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await anular({
          observacion: value,
          expedientes: expedientesData,
        })

        if (ok) {
          showMessage('Éxito!', response?.mensaje, 'success')
          obtenerExpedientes(filtro.value)
        }
        isLoading.value = false
      }
    }

    return {
      credentials: computed(() => store.getters['auth/credentials']),
      cuModalOnClose,
      diplomaModalOnClose,
      sortColumn,
      ascending,
      expedientes,
      sortTable,
      filtro,
      isFilterPanelActive,
      isLoading,
      mostrarCUModal,
      mostrarDiplomaModal,
      mostrarSuneduModal,
      mostrarRegistroLibroModal,
      verRegistroLibro,
      registroLibroModalOnClose,
      obtenerExpedientes,
      pagination,
      recepcionar,
      suneduModalOnClose,
      verConsejoUniversitario,
      verDiploma,
      verSunedu,
      descargarFut,
      descargarFichaCU,
      descargarFichaLibro,
      filterDate,
      seleccionarTodos,
      seleccionar,
      todoSeleccionado,
      expedienteProgramar,
      expedienteObservarSunedu,
      expedienteNoRecogido,
      expedienteFinalizar,
      expedienteAnular,
      icons: {
        mdiAlertDecagramOutline,
        mdiCertificateOutline,
        mdiClipboardCheckOutline,
        mdiCloseOctagonOutline,
        mdiDotsVertical,
        mdiDownloadBoxOutline,
        mdiDownloadCircleOutline,
        mdiFilterVariantMinus,
        mdiOfficeBuildingMarkerOutline,
        mdiSchoolOutline,
        mdiSendCircleOutline,
        mdiSendOutline,
        mdiBookOutline,
        mdiChevronUp,
        mdiChevronDown,
      },
    }
  },
})
